<template>
    <DialogBase class="dialog-rating">

        <template #title>
            Rate&nbsp;{{ name }}
        </template>

        <template #content>
            <div class="text">
                Please rate the generation quality of the&nbsp;{{ name }}.
            </div>
            <div class="likert">
                <v-rating
                    hover 
                    length="5" 
                    color="color1" 
                    item-label-position="bottom" 
                    v-model="rating" 
                    :item-labels="['poor', '', '', '', 'excellent']">
                </v-rating>
            </div>
            <!--
                OPTIONAL: add to the marketplace (public)
                <v-checkbox 
                    hide-details 
                    color="color1" 
                    label="Share the model with the community anonymously." 
                    v-model="public">
                </v-checkbox>
            -->
        </template>

        <template #actions>
            <v-btn 
                variant="elevated" 
                elevation="2" 
                color="surface" 
                @click="handleClose">
                Close
            </v-btn>
        </template>

    </DialogBase>
</template>

<script>
import LEVELS from '@generio-ai/library-legacy/constants/levels'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { DialogBase } from '@generio-ai/library-legacy/components/dialogs'

export default {
    name: 'DialogRating',
    components: {
        DialogBase
    },
    props: {
        asset: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            rating: 0,
            public: false
        }
    },
    computed: {
        name() {
            const name = this.asset?.additional?.category
            if (name) return name.charAt(0).toUpperCase() + name.slice(1)
            return ''
        }
    },
    watch: {
        rating(newVal, oldVal) {
            if (newVal === oldVal) return
            this.handleRating()
        },
        public(newVal, oldVal) {
            if (newVal === oldVal) return
            this.handlePublic()
        }
    },
    methods: 
    {
        ...mapActions('assets', [
            'updateAdditional'
        ]),
        ...mapActions('dialogs', [
            'close'
        ]),
        ...mapActions('notifications', [
            'show'
        ]),
        handleClose()
        {
            this.close()
        },
        handleRating() {
            if (this.asset.additional.rating === this.rating) return
            //this.asset.additional.rating = this.rating
            this.updateAdditional({
                asset: this.asset,
                additional: {
                    rating: this.rating
                }
            })
            .then(response => {
                this.show({
                    message: 'The ' + name + ' rating has been updated.',
                    level: LEVELS.INFORMATION
                })
            })
            .catch(error => {
                this.show({
                    message: 'The ' + name + ' rating could not be updated.',
                    level: LEVELS.ERROR
                })
            })                
        },
        handlePublic() {
            if (this.asset.additional.public === this.public) return
            //this.asset.additional.public = this.public
            this.updateAdditional({
                asset: this.asset,
                additional: {
                    public: this.public
                }
            })
            .then(response => {
                this.show({
                    message: this.public ?
                        'Thank you for adding the model to the public library.' :
                        'The model is not included in the public library anymore.'
                })
            })
            .catch(error => {
                this.show({
                    message: this.public ?
                        'The model could not be added to the public library.' :
                        'The model could not be removed from the public library.',
                    level: LEVELS.ERROR
                })
            })
        }
    }
}
</script>

<style scoped>
.dialog-rating .text {
    color: rgb(var(--v-theme-primary));
}

.dialog-rating .likert {
    margin-top: 20px;
}

.dialog-rating .v-checkbox {
    display: flex;
    justify-content: center;
    width: 100%;
}
</style>